// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/weight-balance-responsibility.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/weight-balance-responsibility/weight-balance-responsibility.js';

mount([g0]);
